


























































































































































































































import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";

@Component
export default class CustomEditComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  @Prop({ type: String, required: false }) private dialogText!: string;
  costTypeA = true;
  costTypeB = false;
  defData: object = {};
  unitSelections: object = {};
  marginSelections: string[] = [];

  mounted(): void {
    if (this.$route.params.id === undefined) {
      return;
    } else {
      this.unitSelections = {
        quantity: this.$t("message.customEdit.unitLabels.quantity") as string,
        sheet: this.$t("message.customEdit.unitLabels.sheet") as string,
        impression: this.$t(
          "message.customEdit.unitLabels.impression"
        ) as string,
        areaSize: this.$t("message.customEdit.unitLabels.areaSize") as string,
        imposition: this.$t(
          "message.customEdit.unitLabels.imposition"
        ) as string
      };
      this.marginSelections = [
        this.$t("message.customEdit.marginLabels.notApply") as string,
        this.$t("message.customEdit.marginLabels.apply") as string
      ];
      this.defData = {
        id: this.$route.params.id,
        itemCustomName: "",
        costType: "fixed",
        unit: "quantity",
        description: "",
        fixedCost: 0,
        minCost: null,
        marginApplicable: 0,
        customFlexibleCosts: [
          {
            itemCustomId: this.$route.params.id,
            sheetFrom: 0,
            sheetTo: -1,
            cost: 1
          }
        ]
      };

      let url = this.$debugServer + "/api/v1_inner/custom/";
      let accessMethod = "post";
      /** 新規の場合 */
      if (this.$route.params.id === "-1") {
        this.costTypeA = true;
        this.costTypeB = false;
        this.editData = {
          custom: this.defData
        };
        return;
      } else {
        url += this.$route.params.id + "/edit";
        accessMethod = "get";
      }
      const params: object = this.setAxiosParams(url, accessMethod);

      axios(params)
        .then((response: any): void => {
          this.editData = response.data;
          if (this.editData.custom.costType === "fixed") {
            this.costTypeA = true;
            this.costTypeB = false;
          } else {
            this.costTypeA = false;
            this.costTypeB = true;
          }
        })
        .catch((error: any): void => {
          console.log("[mount error]", error.response);
          this.toLoginPage(error);
        });
    }
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const editData: any = this.editData;
    const bool: boolean = this.resetSheetFromEle();
    if (bool === true) {
      return;
    }

    const sheetValueCheck: number[] = this.checkSheetValue(
      editData.custom.customFlexibleCosts
    );

    /** sheetFromおかしかったらエラー出す */
    if (sheetValueCheck[1] !== -1) {
      this.showSheetFromError(sheetValueCheck);
      return;
    }
    /** itemCustomId統一(新規継続対策) */
    for (const item of editData.custom.customFlexibleCosts) {
      item.itemCustomId = editData.custom.id;
    }
    /** 問題なかったらsheetToの値を設定 */
    this.setSheetTo(editData.custom.customFlexibleCosts);
    if (this.editData.custom.costType === "minimum") {
      this.editData.custom.fixedCost = null;
    } else {
      this.editData.custom.minCost = null;
    }

    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "custom",
      backTo: "Custom",
      dataName: "custom"
    };
    const id: number = parseInt(editData.custom.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    void 0;
  }

  changeCostType(costType: string): void {
    const data: any = this.editData.custom;
    data.costType = costType;
    /** 初期値を設定する  */
    if (costType === "minimum") {
      this.editData.custom.minCost =
        this.editData.custom.minCost === null
          ? 0
          : this.editData.custom.minCost;
    } else {
      if (this.editData.custom.fixedCost === null) {
        this.editData.custom.fixedCost =
          this.editData.custom.fixedCost === null
            ? 0
            : this.editData.custom.fixedCost;
      }
    }
  }
}
